import { Button, Col, DatePicker, Form, Modal, Row, Select, Space, Switch, Table, Tooltip } from 'antd';
import { useContext, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { SocketContext } from '../../../App';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import arrayHandle from '../../../utilsTs/baseLib/arrayHandle';
import objectHandle from '../../../utils/baseLib/objectHandle';

const { RangePicker } = DatePicker;

export default function ProductSaleDetail(props: any) {

    const [form] = Form.useForm();
    const [showForm] = Form.useForm();
    const ref = useRef<any>(undefined);

    /** 数据刷新中 */
    let loadings = false;

    const [filteredInfo, setFilteredInfo] = useState({ productName: [] });
    const [loading, setLoading] = useState(false);

    const [isShowVisible, setIsShowVisible] = useState(false);
    const [isShowData, setIsShowData] = useState<any>();
    const [isShowTableVisible, setIsShowTableVisible] = useState(false);
    const [isShowRows, setIsShowRows] = useState<any>([]);
    const [branchStoreData, setBranchStoreData] = useState();
    const [refresh, setRefresh] = useState(false);

    const [currentData, setCurrentData] = useState(1);
    const [pageSizeData, setPageSizeData] = useState(10);
    const [totalData, setTotalData] = useState(0);

    const [rows, setRows] = useState<any>([]);
    const [sbData, setSbData] = useState<any>();

    const notificationApi = useNotificationInstance();
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        const fetchData = async () => {
            form.setFieldsValue({ "chooseTime": [dayjs(), dayjs()] })

            if (contextData?.currentBranchStoreId) {
                if (contextData?.refresh) {
                    await initArgument();
                }
                else {
                    await initArgument();
                }
            }
        }
        fetchData()
    }, [contextData?.currentBranchStoreId])

    const getFilters = () => {
        if (rows) {
            // 1. 获取所有不重复的部门值
            let productNames: any = [...new Set(rows.map((item: { productName: any; }) => item.productName))];

            // 2. 转换为 filters 需要的格式
            return productNames.map((productName: any) => ({
                text: productName,
                value: productName,
            }));
        }
    };

    // 处理筛选变化
    const handleChange = (pagination: any, filters: any) => {
        setFilteredInfo(filters);
    };

    const handleAction = (productName: any, productId: any) => {
        setIsShowData({
            productName,
            productId
        });

        fetchApi.GET(wmService, {
            apiId: "product",
            apiExtend: 'showSingle',
            apiVariable: productId
        }).then(res => {
            if (res.success) {
                const branchStoreIds = res.data.isShowProductSale;
                let branchStoreRows;
                if (objectHandle.isEmpty(branchStoreIds) === false) {
                    branchStoreRows = branchStoreIds.split('@');
                }
                showForm.setFieldsValue({ branchStoreIds: branchStoreRows })
            }
        })

        fetchApi.GET(wmService, {
            apiId: "branchStore",
            apiExtend: 'showList'
        }).then(res => {
            if (res.success) {
                newBranchStoreData(res.data, setBranchStoreData, false);
            }
        })
    }

    // 编辑该原材料不再显示
    const handleIsShow = (record: any, refresh: boolean, path: any) => {
        // console.log(record);
        let productName;
        let productId;
        setIsShowVisible(true);
        setRefresh(refresh);
        //判断一下path是否原始数据，transformed为改动过的，origin是原始数据
        if (path === 'transformed') {
            if (record.productId !== '') {
                productName = record.productName.slice(0, record.productName.indexOf("-") - 1);
                productId = record.productId;
                handleAction(productName, productId);
            }
            else {
                antMessage("error", '错误', "暂未设置主配料，暂不能不显");
                setIsShowVisible(false);
                showForm.setFieldsValue({ "branchStoreIds": null })
            }
        }
        else {
            productName = record.productName;
            productId = record.id;
            handleAction(productName, productId);
        }
    };

    // 关闭编辑弹窗
    const closeIsShow = () => {
        setIsShowVisible(false);
        showForm.setFieldsValue({ "branchStoreIds": null })
    };

    /**
     * 获取数据
     * @param options 选项
     * @returns 
     */
    const getPageData = async (options?: {
        /** 当前页 */
        current?: number,
        /** 分页数量 */
        pageSize?: number,
    }) => {
        if (typeof options === 'undefined') {
            options = {};
        }

        let { current, pageSize } = options;
        current = current ? current : currentData;
        pageSize = pageSize ? pageSize : pageSizeData;
        if (loadings === true) { return }
        loadings = true;
        fetchApi.GET(wmService, {
            apiId: "product",
            apiExtend: 'showPage',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                current,
                pageSize,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success === true) {
                setIsShowRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setTotalData(res.data.total);
            }
            loadings = false;
        })
    };

    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: () => `共${totalData}条`,
        pageSize: pageSizeData,
        current: currentData,
        total: totalData,
        onShowSizeChange: (current: number, pageSize: number) =>
            getPageData({ current, pageSize }),
        onChange: (current: number) =>
            getPageData({ current }),
    };

    const refreshData = () => {
        fetchApi.GET(wmService, {
            apiId: "product",
            apiExtend: 'showPage',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                current: currentData,
                pageSize: pageSizeData,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success) {
                setIsShowRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setTotalData(res.data.total);
            }
        })
    }

    // 打开表格(显示那些不显示的原材料)弹窗
    const isShowTable = () => {
        setIsShowTableVisible(true);
        refreshData();
    };

    // 关闭表格(显示那些不显示的原材料)弹窗
    const closeIsShowTable = () => {
        setIsShowTableVisible(false);
        setCurrentData(1);
        setPageSizeData(10);
        setTotalData(0);
    };

    const handleUpdateOne = (record: any, state: boolean) => {
        /** 字符串转数组 */
        const branchStoreIds = record.isShowProductSale;
        let branchStoreRows;
        if (objectHandle.isEmpty(branchStoreIds) === false) {
            branchStoreRows = branchStoreIds.split('@');
        }

        /** 数组转字符串 */
        let branchStoreIdStr;
        if (objectHandle.isEmpty(arrayHandle.deleteValue(branchStoreRows, contextData?.currentBranchStoreId).data) === false) {
            branchStoreIdStr = arrayHandle.deleteValue(branchStoreRows, contextData?.currentBranchStoreId).data.join('@');
        }

        fetchApi.PUT(wmService, {
            apiId: "product",
            apiExtend: 'updateOne',
            apiVariable: record.id,
            apiData: {
                columnName: 'isShowProductSale',
                value: branchStoreIdStr,
            }
        }).then((res) => {
            if (res.success) {
                if (state) {
                    refreshData();
                }
            }
        })
    };

    const handleOk = () => {
        setLoading(true);
        showForm.validateFields()
            .then((values: any) => {
                /** 数组转字符串 */
                let branchStoreIdStr;
                if (objectHandle.isEmpty(values.branchStoreIds) === false) {
                    branchStoreIdStr = values.branchStoreIds.join('@');
                }

                fetchApi.PUT(wmService, {
                    apiId: "product",
                    apiExtend: 'updateOne',
                    apiVariable: isShowData.productId,
                    apiData: {
                        columnName: 'isShowProductSale',
                        value: branchStoreIdStr,
                    }
                }).then((res) => {
                    if (res.success) {
                        closeIsShow();
                        if (refresh) {
                            refreshData();
                        }
                        setLoading(false);
                    }
                }).catch((err) => {
                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: '错误',
                        description: err,
                    });
                    setLoading(false);
                })
            })
            .catch((err) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
                setLoading(false);
            })
    };

    const newBranchStoreData = async (rows: any, setData: any, key: any) => {
        let newSelectData: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            const res = await fetchApi.GET(wmService, {
                apiId: "branchStore",
                apiExtend: 'showListManage'
            })

            let tempData = arrayHandle.find(res.data, rows[j].id, {
                queryNames: "id",
                isMustEqual: true
            });

            newSelectData.push({
                value: rows[j].id,
                label: rows[j].branchStoreName,
                disabled: tempData.data?.length ? key : !key
            })
        }
        setData(newSelectData);
    }

    //表头
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 50,
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 6 ? text.substring(0, 6) + '....' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '品名',
            dataIndex: 'productName',
        },
        {
            title: '操作',
            dataIndex: 'operation',
            render: (text: any, record: any) => {
                return (
                    <div>
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleUpdateOne(record, true)}>当店需要显示</Button>
                            <Button size={"small"} type="primary" onClick={() => handleIsShow(record, true, 'origin')}>调整其他门店</Button>
                        </Space>
                    </div>
                )
            }
        },
    ];

    //表头
    const columnsHead = [
        {
            title: '原材料',
            dataIndex: 'productName',
            onCell: (record: { dataNum: number; }) => ({
                rowSpan: record.dataNum,
            }),
            filteredValue: filteredInfo.productName || null,
            filters: getFilters(),
            onFilter: (value: any, record: any) => record.productName === value,
            filterSearch: true,
            render: (text: any, record: any) => {
                return (
                    <div>
                        <Space size="small">
                            {text}
                            <Button size={"small"} type="primary" onClick={() => handleIsShow(record, false, "transformed")}>不显示</Button>
                        </Space>
                    </div>
                )
            }
        },
        {
            title: '总消耗',
            dataIndex: 'productTotal',
            onCell: (record: { dataNum: number; }) => ({
                rowSpan: record.dataNum,
            }),
        },
        {
            title: '各款菜式消耗情况',
            dataIndex: 'usedDetail',
            children: [
                {
                    title: '菜名',
                    dataIndex: 'foodName',
                    width: 300,
                },
                {
                    title: '规格',
                    dataIndex: 'menuSpecName',
                    width: 100,
                },
                {
                    title: '销售额',
                    dataIndex: 'advancePrice',
                    width: 100,
                },
                {
                    title: '毛利率',
                    dataIndex: 'grossProfitRatio',
                    width: 100,
                    render: (text: any, record: any) => {
                        if (record.grossProfitRatio) {
                            return (
                                <div>{record.grossProfitRatio + " %"}</div>
                            )
                        }
                    }
                },
                {
                    title: '销售数量',
                    dataIndex: 'amount',
                    width: 100,
                },
                {
                    title: '原材料共消耗',
                    dataIndex: 'total',
                    width: 150,
                },
            ]
        },
    ];

    const initArgument = async () => {
        let sb = await fetchApi.GET(wmService, {
            apiId: "sb",
            apiExtend: 'getBrandStoreIdToSb',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId
            }
        })

        if (sb.success) {
            setSbData(sb.data);
        }

        form.resetFields(["sbId"])
        setRows([]);
        setContextData({ ...contextData, refresh: false });
    }

    const onFinish = () => {
        setLoading(true);
        let branchStoreId = contextData?.currentBranchStoreId;
        if (!branchStoreId) {
            antMessage("error", '错误', "必须选择分店");
            return false;
        }
        form.validateFields()
            .then((values: any) => {
                if (!loading) {
                    fetchApi.GET(wmService, {
                        apiId: "financeReport",
                        apiExtend: 'salesDetail',
                        apiData: {
                            ...values,
                            branchStoreId,
                            showSum: false,
                            isGroupByShopType: false,
                            isQuadraticFunction: true  //true就执行productSaleDetailData方法
                        }
                    }).then((res) => {
                        if (res.success) {
                            setRows(res.data.rows);
                            setLoading(false);
                            setFilteredInfo({ productName: [] });
                        }
                    }).catch((err) => {
                        showCustomNotification(notificationApi!, {
                            type: 'error',
                            message: '错误',
                            description: err,
                        });
                        setLoading(false);
                    })
                }
            })
            .catch((err) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
                setLoading(false);
            })
    }

    return (
        <>
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={3}>
                        <Form.Item>
                            <Button type="primary" onClick={isShowTable}>查看不显示的原材料</Button>
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            label="市别"
                            name="sbId"
                        >
                            <Select
                                allowClear
                                placeholder="市别"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(sbData, 'sbName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="日期"
                            name="chooseTime"
                        >
                            <RangePicker
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="菜谱统计"
                            name="isCombinedRecipeStatistics"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch checked={true}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="父项"
                            name="isSetMeal"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={false}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" disabled={loading}>统计</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <div>
                <Modal
                    zIndex={10}
                    title={"不显示的原材料"}
                    open={isShowTableVisible}
                    closable={false}
                    onOk={closeIsShowTable}
                    okText={"关闭"}
                    cancelButtonProps={{ style: { display: "none" } }}
                    width={800}
                >
                    <Table
                        pagination={paginationProps}
                        rowKey={(record: any) => record.id}
                        columns={columns}
                        dataSource={isShowRows}
                    >
                    </Table>
                </Modal>
            </div>

            <div>
                <Modal
                    zIndex={20}
                    title={"设置【 " + isShowData?.productName + " 】不显示的门店"}
                    open={isShowVisible}
                    closable={false}
                    maskClosable={false}
                    cancelButtonProps={{ disabled: loading }}
                    okButtonProps={{ disabled: loading }}
                    onOk={handleOk}
                    onCancel={closeIsShow}
                    width={800}
                >
                    <Form
                        form={showForm}
                        name="Edit"
                        style={{ height: 450 }}
                    >
                        <Form.Item
                            label="选择门店"
                            name="branchStoreIds"
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="选择选择门店"
                                optionFilterProp="children"
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                                options={branchStoreData}
                            >
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>

            <div style={{ marginTop: "20px" }}>
                <Table
                    scroll={{ x: "100%", y: 600 }}
                    bordered={true}
                    pagination={false}
                    rowKey={(record: any) => record.id}
                    columns={columnsHead}
                    dataSource={rows}
                    onChange={handleChange}
                    // loading={loading}
                    loading={{
                        spinning: loading,
                        tip: '正在统计数据，请稍后...' // 自定义提示文字
                    }}
                >
                </Table>
            </div>
        </>
    )
}